module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Regular-Italic.8234806b.ttf";